import { supabase } from '../lib/supabase-client';
export const notificationsService = {
    /**
     * Fetch unread notifications for current user (alias for fetchUserNotifications)
     */
    async getUnreadNotifications(userId, limit = 10) {
        try {
            const { data, error } = await supabase
                .from('notifications')
                .select('*')
                .eq('user_id', userId)
                .eq('read', false)
                .order('created_at', { ascending: false })
                .limit(limit);
            if (error) {
                console.error('Error fetching notifications:', error);
                return [];
            }
            return data || [];
        }
        catch (error) {
            console.error('Failed to fetch notifications:', error);
            return [];
        }
    },
    /**
     * Fetch unread notifications for current user
     */
    async fetchUserNotifications(userId, limit = 10) {
        try {
            const { data, error } = await supabase
                .from('notifications')
                .select('*')
                .eq('user_id', userId)
                .eq('read', false)
                .order('created_at', { ascending: false })
                .limit(limit);
            if (error) {
                console.error('Error fetching notifications:', error);
                return [];
            }
            return data || [];
        }
        catch (error) {
            console.error('Failed to fetch notifications:', error);
            return [];
        }
    },
    /**
     * Mark notification as read
     */
    async markNotificationAsRead(notificationId) {
        try {
            const { error } = await supabase
                .from('notifications')
                .update({ read: true, updated_at: new Date().toISOString() })
                .eq('id', notificationId);
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error marking notification as read:', error);
            return false;
        }
    },
    /**
     * Mark all notifications as read for user
     */
    async markAllNotificationsAsRead(userId) {
        try {
            const { error } = await supabase
                .from('notifications')
                .update({ read: true, updated_at: new Date().toISOString() })
                .eq('user_id', userId)
                .eq('read', false);
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error marking all notifications as read:', error);
            return false;
        }
    },
    /**
     * Create a new notification
     */
    async createNotification(notification) {
        try {
            const { data, error } = await supabase
                .from('notifications')
                .insert([{
                    ...notification,
                    created_at: new Date().toISOString(),
                    updated_at: new Date().toISOString()
                }])
                .select()
                .single();
            if (error)
                throw error;
            return data;
        }
        catch (error) {
            console.error('Error creating notification:', error);
            return null;
        }
    },
    /**
     * Delete a notification
     */
    async deleteNotification(notificationId) {
        try {
            const { error } = await supabase
                .from('notifications')
                .delete()
                .eq('id', notificationId);
            if (error)
                throw error;
            return true;
        }
        catch (error) {
            console.error('Error deleting notification:', error);
            return false;
        }
    },
    /**
     * Get unread notification count
     */
    async getUnreadCount(userId) {
        try {
            const { count, error } = await supabase
                .from('notifications')
                .select('id', { count: 'exact' })
                .eq('user_id', userId)
                .eq('read', false);
            if (error)
                throw error;
            return count || 0;
        }
        catch (error) {
            console.error('Error getting unread count:', error);
            return 0;
        }
    }
};
